// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function makeCancelable(waitOpt, fn) {
  var wait = waitOpt !== undefined ? waitOpt : 100;
  var timerId = {
    contents: undefined
  };
  var lastArg = {
    contents: undefined
  };
  var lastCallTime = {
    contents: undefined
  };
  var shouldInvoke = function (time) {
    var lastCallTime$1 = lastCallTime.contents;
    if (lastCallTime$1 === undefined) {
      return true;
    }
    var timeSinceLastCall = time - lastCallTime$1 | 0;
    if (timeSinceLastCall >= wait) {
      return true;
    } else {
      return timeSinceLastCall < 0;
    }
  };
  var remainingWait = function (time) {
    var lastCallTime$1 = lastCallTime.contents;
    if (lastCallTime$1 === undefined) {
      return wait;
    }
    var timeSinceLastCall = time - lastCallTime$1 | 0;
    return wait - timeSinceLastCall | 0;
  };
  var timerExpired = function (param) {
    var timerId$1 = timerId.contents;
    if (timerId$1 !== undefined) {
      clearTimeout(Caml_option.valFromOption(timerId$1));
    }
    var time = Date.now() | 0;
    if (shouldInvoke(time)) {
      var x = lastArg.contents;
      if (x !== undefined) {
        lastArg.contents = undefined;
        timerId.contents = undefined;
        return Curry._1(fn, Caml_option.valFromOption(x));
      } else {
        timerId.contents = undefined;
        return ;
      }
    } else {
      timerId.contents = Caml_option.some(setTimeout(timerExpired, remainingWait(time)));
      return ;
    }
  };
  var schedule = function (x) {
    var time = Date.now() | 0;
    lastArg.contents = Caml_option.some(x);
    lastCallTime.contents = time;
    timerId.contents = Caml_option.some(setTimeout(timerExpired, wait));
    
  };
  var scheduled = function (param) {
    return Belt_Option.isSome(timerId.contents);
  };
  var cancel = function (param) {
    var timerId$prime = timerId.contents;
    if (timerId$prime !== undefined) {
      clearTimeout(Caml_option.valFromOption(timerId$prime));
      timerId.contents = undefined;
      lastArg.contents = undefined;
      lastCallTime.contents = undefined;
      return ;
    }
    
  };
  var now = function (x) {
    cancel(undefined);
    return Curry._1(fn, x);
  };
  return {
          invoke: now,
          schedule: schedule,
          scheduled: scheduled,
          cancel: cancel
        };
}

function make(wait, fn) {
  return makeCancelable(wait, fn).schedule;
}

exports.make = make;
exports.makeCancelable = makeCancelable;
/* No side effect */
